import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/query-client';
import { ProtectedRoute } from './components/layout/ProtectedRoute';
import { AppLayout } from './components/layout/AppLayout';
import { SignInPage } from './pages/SignInPage';
import { SignUpPage } from './pages/SignUpPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { ShareAccomplishmentPage } from './pages/ShareAccomplishmentPage';
import { HouseholdPage } from './pages/HouseholdPage';
import { ChoreDefinitionsPage } from './pages/ChoreDefinitionsPage';
import { AssignmentsPage } from './pages/AssignmentsPage';
import { HouseholdSettingsPage } from './pages/HouseholdSettingsPage';
import { CalendarPage } from './pages/CalendarPage';
import { RoomsPage } from './pages/RoomsPage';
import { AcceptInvitationPage } from './pages/AcceptInvitationPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { DesignLabPage } from './pages/DesignLabPage';
import { WidgetLabPage } from './pages/WidgetLabPage';
import { HomeViewPage } from './pages/HomeViewPage';
import { SelectedHouseholdProvider } from './context/SelectedHouseholdContext';
import { ActiveMemberProvider } from './context/ActiveMemberContext';
import { CelebrationProvider } from './components/Celebration';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <CelebrationProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/invitations/:token" element={<AcceptInvitationPage />} />
          {!__NATIVE__ && <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />}
          {/* Unlisted design-review galleries (mock data, no auth) */}
          <Route path="/design-lab" element={<DesignLabPage />} />
          <Route path="/design-lab/widget" element={<WidgetLabPage />} />


          {/* Protected routes */}
          <Route element={<ProtectedRoute />}>
            <Route
              path="/home-view"
              element={<SelectedHouseholdProvider><HomeViewPage /></SelectedHouseholdProvider>}
            />
            <Route element={<SelectedHouseholdProvider><ActiveMemberProvider><AppLayout /></ActiveMemberProvider></SelectedHouseholdProvider>}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/share" element={<ShareAccomplishmentPage />} />
              <Route path="/household" element={<HouseholdPage />} />
              <Route path="/chore-definitions" element={<ChoreDefinitionsPage />} />
              <Route path="/assignments" element={<AssignmentsPage />} />
              <Route path="/household-settings" element={<HouseholdSettingsPage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/rooms" element={<RoomsPage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      </CelebrationProvider>
    </QueryClientProvider>
  );
}
